import { connect } from 'react-redux';
import { beginDeviationAwardBadgeFlow } from '../../../coreBadge/redux/actionCreators';
import { getLimitedBadgesPromo } from '../../../publicSession/selectors';
var mapStateToProps = function (state) { return ({
    limitedBadgesPromo: getLimitedBadgesPromo(state),
}); };
var mapDispatchToProps = {
    onAwardClick: beginDeviationAwardBadgeFlow,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=AwardBadgeButton.container.js.map